//

'use strict';
module.exports = ([function () {
        return function (enumVal, enumList) {
            var ret = "";
           
            if (enumVal !== undefined && enumList ) {
                
                angular.forEach(enumList, function (value,key) {
                    
                    if (key === enumVal) {
                        
                        ret= value;
                    }
                });
            }
            return ret;
        };
    }]);





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/filters/datex2EnumsTranscodeFilter.js
// module id = 276
// module chunks = 0